import type { Distance, Rectangle, SpatialRectangle } from "@pdfking/math"

export type Media<T = Distance> = {
  readonly media_box: SpatialRectangle<T>
  readonly size: Rectangle<T>
  readonly trim_box: SpatialRectangle<T>
}
